import { useState, useEffect, useRef } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function NewsletterManage() {
  // Read the token ONCE from the URL, hold it only in memory, then strip it from
  // the address bar so it never lingers in history, screenshots, or referrers.
  const tokenRef = useRef(
    new URLSearchParams(window.location.search).get("token") || ""
  );
  const [hasToken] = useState(Boolean(tokenRef.current));
  const [prefs, setPrefs] = useState(null);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    // Remove token from the visible URL immediately (before any await).
    if (tokenRef.current) {
      window.history.replaceState(null, "", "/newsletter/manage");
    }
    if (!tokenRef.current) return;
    api
      .get("/public/newsletter/preferences", {
        headers: { "X-Manage-Token": tokenRef.current },
      })
      .then((r) => { setPrefs(r.data); setSelected(r.data.newsletters); })
      .catch(() => setPrefs(false));
  }, []);

  const save = async () => {
    try {
      await api.post("/public/newsletter/preferences", { newsletters: selected }, {
        headers: { "X-Manage-Token": tokenRef.current },
      });
      toast.success("Preferences updated");
    } catch { toast.error("Could not update"); }
  };
  const unsubAll = async () => {
    try {
      await api.post("/public/newsletter/unsubscribe", { token: tokenRef.current, all: true });
      toast.success("Unsubscribed from all");
      setSelected([]);
      setPrefs({ ...prefs, status: "unsubscribed" });
    } catch { toast.error("Could not unsubscribe"); }
  };

  if (!hasToken) return <div data-testid="manage-invalid" className="max-w-lg mx-auto px-4 py-24 text-center text-ink/60">Invalid management link.</div>;
  if (prefs === null) return <div className="max-w-lg mx-auto px-4 py-24 text-ink/55">Loading…</div>;
  if (prefs === false) return <div data-testid="manage-expired" className="max-w-lg mx-auto px-4 py-24 text-center"><h1 className="font-editorial text-2xl font-bold text-ink">Link expired or invalid</h1></div>;

  return (
    <div className="max-w-lg mx-auto px-4 sm:px-6 py-16">
      <title>Manage Newsletter Preferences | Be-Apuo</title>
      <meta name="referrer" content="no-referrer" />
      <div className="label-caps text-clay">Newsletter</div>
      <h1 className="mt-2 font-editorial font-black text-3xl tracking-tight text-ink">Manage your preferences</h1>
      <p className="mt-2 text-sm text-ink/55">{prefs.email_masked} · status: {prefs.status}</p>

      <div className="mt-8 space-y-2" data-testid="newsletter-prefs">
        {prefs.all_newsletters.map((n) => (
          <label key={n} className="flex items-center gap-3 border border-ink/10 bg-white px-4 py-3 cursor-pointer hover:border-heritage transition-colors">
            <input type="checkbox" checked={selected.includes(n)} className="accent-heritage"
              onChange={(e) => setSelected(e.target.checked ? [...selected, n] : selected.filter((x) => x !== n))} />
            <span className="text-ink">{n}</span>
          </label>
        ))}
      </div>
      <div className="mt-6 flex gap-3">
        <button data-testid="save-prefs-btn" onClick={save} className="bg-heritage text-paper px-5 py-2.5 text-sm font-semibold hover:bg-heritage/90 transition-colors">Save preferences</button>
        <button data-testid="unsub-all-btn" onClick={unsubAll} className="border border-clay text-clay px-5 py-2.5 text-sm font-semibold hover:bg-clay hover:text-paper transition-colors">Unsubscribe from all</button>
      </div>
    </div>
  );
}
